import { unitList } from "constants/unit";

const initialState = {
  unitList: {},
};

const unit = (state = initialState, action) => {
  switch (action.type) {
    case unitList:
      return { ...state, unitList: action.payload };
    default:
      return state;
  }
};

export default unit;